import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const LineGraph: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>   
   <path d="M3.00024 22H20.0002" stroke={color} strokeWidth="2" strokeLinecap="round"/>
   <path d="M3 19L7 13L13 17L20.5 3" stroke={color}  strokeWidth="2" strokeLinecap="round"/>
</svg>);
export default LineGraph;